import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { Box, ThemeProvider, useTheme } from '@mui/material';
import warningTheme, { WD } from './warningTheme';

// Pathless layout route wrapping every /warning-dashboard/* screen: scopes the cream/green theme to the
// warning dashboard only (nested ThemeProvider over the portal's own theme) and paints the canvas behind it.
const WarningThemeLayout = () => {
  const outer = useTheme();
  const theme = useMemo(() => warningTheme(outer), [outer]);
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ bgcolor: WD.canvas, color: WD.ink, minHeight: '100%', borderRadius: 3, p: { xs: 1, md: 2 }, fontFamily: theme.typography.fontFamily }}>
        <Outlet />
      </Box>
    </ThemeProvider>
  );
};

export default WarningThemeLayout;
